const INITIAL_STATE = {
  data: {},
  franchiseList:[],
  dailyReports:{},
  errors: {},
}
    
const getDailyLogs = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_DAILY_LOG_FRANCHISE_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, franchiseList: action.data }
  case 'GET_DAILY_LOG_FRANCHISE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_DAILY_LOG_REPORTS_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, dailyReports: action.data }
  case 'GET_DAILY_LOG_REPORTS_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default getDailyLogs;